/**
 * Przełączniki funkcji obszaru „lista zleceń i Trade” (decyzja użytkownika
 * 12.10.2026: wersja „obecna” = produkcja 0.31.3, zmiany z develop za
 * przełącznikami). Klucze to dane — lustro rejestru API
 * (`apps/api/src/feature-flags/feature-flags.ts`); nie przemianowujemy.
 * Front tylko ukrywa — filtry i parametry rozstrzyga API.
 */

/** „Do sprzedaży” — zlecenia STANDARD i MEGA (0.31.4). */
export const FEATURE_SALE_RECOMMENDATION = 'saleRecommendation';

/** Kolumna „Giełda” na liście, w eksporcie i mieszczenie przy 1366 px (0.31.4, 0.31.5). */
export const FEATURE_EXCHANGE_COLUMN = 'exchangeColumn';

/** Filtr „Tylko wystawione na giełdzie” (`postedOnExchange`) i nowa etykieta `naGieldzie` (0.31.4). */
export const FEATURE_POSTED_ON_EXCHANGE_FILTER = 'postedOnExchangeFilter';

/** Przewoźnicy z historią: dokładność relacji i kolumna „Dopasowanie” (0.31.4, 0.31.5). */
export const FEATURE_CARRIER_RELATION_PRECISION = 'carrierRelationPrecision';
